import { gql } from '@apollo/client'

import { STATUS } from 'features/BaseRules/components/Status/constants'
import { baseRuleIsScheduled } from 'resolvers/baseRules'

export const resolvers = {
  Mutation: {
    activateFareRule(_root: TSFixMe, { fareRule }: TSFixMe, { cache }: TSFixMe) {
      cache.writeFragment({
        id: cache.identify({
          __typename: 'FareRule',
          id: fareRule.id
        }),
        fragment: gql`
          fragment FareRuleStatus on FareRule {
            status
          }
        `,
        data: {
          status: baseRuleIsScheduled(fareRule) ? STATUS.SCHEDULED : STATUS.ACTIVATED,
          __typename: 'FareRule'
        }
      })

      return null
    },
    deactivateFareRule(_root: TSFixMe, { id }: TSFixMe, { cache }: TSFixMe) {
      cache.writeFragment({
        id: cache.identify({
          __typename: 'FareRule',
          id
        }),
        fragment: gql`
          fragment FareRuleStatus on FareRule {
            status
          }
        `,
        data: {
          status: STATUS.DEACTIVATED,
          __typename: 'FareRule'
        }
      })

      return null
    }
  }
}
